export enum PageDevelopmentStatus {
  InReview = 'in-review',
  Reviewed = 'reviewed',
  Draft = 'draft'
}
